import React from "react";
import Layout from "../../../shared/Layout/Layout";
import NewsHeader from "../../../shared/Components/NewsHeader";
import NationalAdvisoryDetails from "./component/NationalAdvisoryDetails";

export default function NationalAdvisory() {
  return (
    <Layout>
      <NewsHeader>
        Formation Of National Advisory Board For Impact Investment In Bangladesh
      </NewsHeader>
      <NationalAdvisoryDetails />
    </Layout>
  );
}
